import { solanaPubkeyBase58 } from "@stealthos/sdk";
import { fail } from "./common";

const localLocks = new Set<string>();

/**
 * One settlement lease per privacy account across selection, proving,
 * journaling, signing and finalization. Web Locks give cross-tab safety; the
 * in-process fallback still prevents duplicate work in older browsers.
 */
export async function withSolanaWalletLock<T>(params: {
  networkKey: string;
  programId: string;
  account: string;
  signal?: AbortSignal;
  run: () => Promise<T>;
}): Promise<T> {
  const name = `stealthos:solana-joinsplit-v2:${params.networkKey}:${solanaPubkeyBase58(params.programId, "programId")}:${solanaPubkeyBase58(params.account, "account")}`;
  if (params.signal?.aborted) fail("operation was cancelled");
  const locks = globalThis.navigator?.locks;
  if (locks) {
    return locks.request(
      name,
      { mode: "exclusive", ifAvailable: true },
      async (lock) => {
        if (!lock) {
          fail("another tab is already preparing a private settlement");
        }
        if (params.signal?.aborted) fail("operation was cancelled");
        return params.run();
      },
    );
  }
  if (localLocks.has(name)) fail("a private settlement is already in progress");
  localLocks.add(name);
  try {
    if (params.signal?.aborted) fail("operation was cancelled");
    return await params.run();
  } finally {
    localLocks.delete(name);
  }
}
